
(() => {
  if (window.__arMinimalPackagingInitialized) return;
  window.__arMinimalPackagingInitialized = true;

  const checkboxId = 'Minimal-Packaging-Drawer';
  let isSaving = false;
  let pendingSave = Promise.resolve(true);

  function updateHiddenInput(checkbox) {
    const hiddenInput = checkbox.form?.querySelector(
      'input[name="attributes[Minimal Packaging]"]'
    );

    if (hiddenInput) {
      hiddenInput.value = checkbox.checked ? 'Yes' : 'No';
    }
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target;

    if (
      !(checkbox instanceof HTMLInputElement) ||
      checkbox.id !== checkboxId
    ) {
      return;
    }

    const selected = checkbox.checked;
    const previousChecked = !selected;

    updateHiddenInput(checkbox);
    checkbox.disabled = true;
    isSaving = true;

    pendingSave = (async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';

        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Minimal Packaging': selected ? 'Yes' : ''
            }
          })
        });

        if (!response.ok) {
          throw new Error(`Cart update failed: ${response.status}`);
        }

        const cart = await response.json();

        if (
          selected &&
          cart.attributes?.['Minimal Packaging'] !== 'Yes'
        ) {
          throw new Error('Cart attribute was not saved as expected.');
        }

        return true;
      } catch (error) {
        checkbox.checked = previousChecked;
        updateHiddenInput(checkbox);
        console.error('Minimal Packaging:', error);
        alert(
          'Unable to save your packaging preference. Please try again.'
        );
        return false;
      } finally {
        checkbox.disabled = false;
        isSaving = false;
      }
    })();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      event.submitter?.name !== 'checkout' ||
      !form.querySelector(`#${checkboxId}`) ||
      !isSaving
    ) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitter = event.submitter;
    const saved = await pendingSave;

    if (saved && submitter.isConnected) {
      form.requestSubmit(submitter);
    }
  }, true);
})();
